<div class="mail-toast" (click)="onClickToast()">
  <div class="d-flex align-items-center">
    <mat-icon class="mail-toast__icon">mail</mat-icon>

    <div class="mail-toast__content">
      <div class="mail-toast__title">{{ title }}</div>
      <div class="mail-toast__message" [innerHTML]="message"></div>
    </div>
  </div>

  <button
    mat-icon-button
    class="mail-toast__close"
    (click)="close()"
    aria-label="Close"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
